<template>
  <b-alert :model-value="true" variant="info" class="legacy-retirement-banner">
    <font-awesome-icon icon="circle-info" class="tw:mr-2" />
    This Classic console will be retired after December 31, 2026. We'd love to help you feel
    at home in the new console before then, and your feedback helps us get it right.
  </b-alert>
</template>
